import { computed, ref } from 'vue'

export function useDefaultFieldValues<T>(field: { defaultValue?: T | null }) {
  const userWantsDefaultValue = ref(false)

  const hasDefaultValue = computed(() => {
    const value = field.defaultValue
    if (value === null || value === undefined) return false
    if (typeof value === 'string' && value.trim() === '') return false
    if (typeof value === 'boolean') return true
    return true
  })

  const showDefaultValue = computed(() => {
    return hasDefaultValue.value || userWantsDefaultValue.value
  })

  function toggleDefaultValue(checked: boolean) {
    if (checked) {
      userWantsDefaultValue.value = true
    } else {
      userWantsDefaultValue.value = false
      field.defaultValue = null as T | null
    }
  }

  return {
    showDefaultValue,
    toggleDefaultValue,
    userWantsDefaultValue,
  }
}
